<template>
  <div class="swiper-slide-container" @click="handleClick">
    <div :class="['background-image', { active: isActive }]">
      <div class="background-image__inner">
        <p :class="['description', { active: isActive }]">{{ description }}</p>
      </div>
    </div>
    <p class="text">{{ text }}</p>
    <div class="line-container">
      <div class="line" :style="{ backgroundColor: isFirst ? 'transparent' : '#ffd700' }"></div>
      <div class="circle"></div>
      <div class="line-right" :style="{ backgroundColor: isLast ? 'transparent' : '#ffd700' }"></div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false, // 默认状态为非 active
    },

    isFirst: {
      type: Boolean,
      default: false,
    },

    isLast: {
      type: Boolean,
      default: false,
    }

  },
  data () {
    return {

    }
  },

  methods: {
    handleClick () {
      this.$emit('slideClick') // 发出事件通知父组件
    },
  },
}
</script>

<style scoped lang="less">
.swiper-slide-container {
  position: relative;

}

.swiper-slide-container .description {
  color: 595959;
}

.swiper-slide-container:hover .description {
  color: white;
  font-weight: 400;
}

.swiper-slide-container .background-image {
  background: url('../../assets/images/homeV2/swiperCardDefaultV2.png') no-repeat center;
  background-size: contain;
}

.swiper-slide-container:hover .background-image {
  background: url('../../assets/images/homeV2/swiperCardActiveV2.png') no-repeat center;
  background-size: contain;
}

/* 用来显示背景图片的 div */
.background-image {
  /* width: 85%; */
  width: 100%;
  aspect-ratio: 554 / 318;
  position: relative;
  box-sizing: border-box;

  /* background-size: cover; */
  background-position: center;
  /* margin-left: 55px;
    margin-top: 80px; */
  background: url('../../assets/images/homeV2/swiperCardDefaultV2.png') no-repeat center;
  background-size: contain;
  display: flex;
  align-items: center;

  justify-content: center;

  background-color: #262626;

}

@supports not (aspect-ratio: 554 / 318) {
  .background-image {
    padding-top: calc(100% * 318 / 554);

  }
}

.background-image__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.description {
  margin-left: 70px;
  margin-right: 70px;
  margin-top: -10px;
  // color: #595959;
  // font-size: 20px;
  // font-family: "PingFang SC-Regular";
  font-family: PingFang SC, PingFang SC;
font-weight: 300;
font-size: 20px;
color: #595959;
line-height: 38px;
text-align: left;
font-style: normal;
text-transform: none;
}


.text {
  color: #262626;
  font-size: 36px;
  font-family: "PingFang SC-Medium";
  margin-left: 80px;
  margin-top: 20px;
  margin-bottom: 20px;
}

/* 使 line, circle 和 line-right 保持水平对齐 */
.line-container {
  display: flex;
  align-items: center;
  /* 保持所有元素在垂直方向居中 */
  /* margin-top: 20px; */
  margin-bottom: 0;
  width: 100%;
}

.line {
  width: 90px;
  height: 8px;
  background-color: #ffd700;
  margin-right: 12px;
  opacity: 0.1;
}

.circle {
  width: 20px;
  height: 20px;
  background-color: #ffd700;
  border-radius: 50%;
  margin-right: 12px;
}

.line-right {
  flex-grow: 1;
  /* 让右侧线条自动占满剩余空间 */
  height: 8px;
  background-color: #ffd700;
  opacity: 0.1;
}

/* 移动设备适配 */
.mobile {

  .swiper-slide-container:hover .description {
    color: #595959;
    /* 禁用 hover 时的白色 */
  }

  .swiper-slide-container .background-image {
    background: url('../../assets/images/homeV2/swiperCardDefaultV2H5.png') no-repeat center;
    background-size: contain;
  }

  .swiper-slide-container:hover .background-image {
    background: url('../../assets/images/homeV2/swiperCardDefaultV2H5.png') no-repeat center;
    background-size: contain;
  }

  .background-image {
    /* width: 100%; */
    aspect-ratio: 190 / 124;
    /* background-size: cover;
        background-position: center; */
    /* margin-left: 0;
        margin-top: 0; */
  }


  .description {
    margin-left: 44px;
    margin-right: 44px;
    font-size: 11px;
    margin-top: -5px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #595959;
    line-height: 18px;
    text-align: justify;
    font-style: normal;
    text-transform: none;
  }

  .description:hover {
    color: white;
  }


  /* .triangle.active {
        border-top: 21px solid #05BD6F;
      } */

  .text {
    font-size: 14px;
    margin-left: 35px;
    margin-top: 0px;
    margin-bottom: 8px;
    font-weight: 500;
  }

  .line-container {
    /* margin-top: 10px; */
  }

  .line {
    width: 43px;
    height: 2px;
    margin-right: 4px;
  }

  .circle {
    width: 6px;
    height: 6px;
    margin-right: 4px;
  }

  .line-right {
    height: 2px;
  }
}
</style>
